(function(){
  requestAnimationFrame(function(){requestAnimationFrame(function(){document.body.classList.add('ready');});});
  // opções de compra
  document.querySelectorAll('[data-opt]').forEach(function(o){
    o.addEventListener('click',function(){o.parentNode.querySelectorAll('[data-opt]').forEach(function(x){x.classList.remove('on');});o.classList.add('on');});
  });
  // quantidade
  document.querySelectorAll('.qty').forEach(function(q){
    var v=q.querySelector('[data-qv]'),n=1;
    q.querySelectorAll('[data-q]').forEach(function(b){b.addEventListener('click',function(){n=Math.max(1,n+parseInt(b.getAttribute('data-q'),10));v.textContent=(n<10?'0':'')+n;});});
  });
  // galeria do produto
  document.querySelectorAll('.gal').forEach(function(g){
    var imgs=g.querySelectorAll('img'),dots=g.querySelectorAll('.dots button'),i=0;
    function go(k){i=(k+imgs.length)%imgs.length;imgs.forEach(function(im,j){im.classList.toggle('on',j===i);});dots.forEach(function(d,j){d.classList.toggle('on',j===i);});}
    var l=g.querySelector('.arr.l'),r=g.querySelector('.arr.r');
    if(l)l.addEventListener('click',function(){go(i-1);});
    if(r)r.addEventListener('click',function(){go(i+1);});
    dots.forEach(function(d,j){d.addEventListener('click',function(){go(j);});});
  });
  // movimento leve ao rolar: colagem da capa (data-px = fator do scroll, só em tela larga) e seção escura (data-pp = amplitude em px)
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches,narrow=window.matchMedia('(max-width:820px)');
  var px=[].slice.call(document.querySelectorAll('[data-px]')).map(function(el){return {el:el.querySelector('.pxw')||el.querySelector('img')||el,k:parseFloat(el.getAttribute('data-px'))||0};});
  var pp=[].slice.call(document.querySelectorAll('[data-pp]')).map(function(el){return {el:el,a:parseFloat(el.getAttribute('data-pp'))||0,box:el.parentNode};});
  var hero=document.querySelector('.hero'),tick=false;
  function frame(){
    tick=false;
    var y=window.pageYOffset||0,vh=window.innerHeight;
    if(hero&&px.length){var off=narrow.matches?0:y;if(off<hero.offsetHeight+vh){px.forEach(function(o){o.el.style.transform='translate3d(0,'+(-off*o.k).toFixed(1)+'px,0)';});}}
    pp.forEach(function(o){var r=o.box.getBoundingClientRect();if(r.bottom<-100||r.top>vh+100)return;var p=Math.min(1,Math.max(0,(vh-r.top)/(vh+r.height)));o.el.style.transform='translate3d(0,'+((p-.5)*o.a).toFixed(1)+'px,0)';});
  }
  function ask(){if(!tick){tick=true;requestAnimationFrame(frame);}}
  if(!reduce&&(px.length||pp.length)){window.addEventListener('scroll',ask,{passive:true});window.addEventListener('resize',ask);frame();}
  // celular e tablet em pé: o cabeçalho (menu completo, duas linhas no celular) some ao rolar para baixo e volta ao rolar para cima
  var hd=document.querySelector('.hd'),lastY=window.pageYOffset||0;
  if(hd){window.addEventListener('scroll',function(){
    var y=window.pageYOffset||0;
    if(!narrow.matches){hd.classList.remove('off');lastY=y;return;}
    if(y>lastY+6&&y>160)hd.classList.add('off');else if(y<lastY-6||y<=160)hd.classList.remove('off');
    lastY=y;
  },{passive:true});}
})();
